import { Outlet } from 'react-router';

import { isNotDefined } from '@enterprise/core';
import { HasAccess, StaticLoader } from '@enterprise/ui';

import RedirectToLogin from '@/app/components/redirects/redirect-login';
import RedirectToDenied from '@/app/components/redirects/redirect-to-denied';
import { useApplicationStore } from '@hooks/application/application-store.hook';

import type { RouteGuardProps } from './types/route-guard.props';

export const RouteGuard = (props: RouteGuardProps) => {
  const user = useApplicationStore(({ user }) => {
    return user;
  });

  if (isNotDefined(user)) {
    return <RedirectToLogin />;
  }

  return (
    <HasAccess
      {...props}
      denied={<RedirectToDenied />}
      loading={<StaticLoader />}>
      <Outlet />
    </HasAccess>
  );
};
